import { render, staticRenderFns } from "./AdminMapPoints.vue?vue&type=template&id=a7f84362&scoped=true"
import script from "./AdminMapPoints.vue?vue&type=script&lang=js"
export * from "./AdminMapPoints.vue?vue&type=script&lang=js"
import style0 from "./AdminMapPoints.vue?vue&type=style&index=0&id=a7f84362&prod&scoped=true&lang=css"
import style1 from "./AdminMapPoints.vue?vue&type=style&index=1&id=a7f84362&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f84362",
  null
  
)

export default component.exports